// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useParams } from 'react-router-dom';
// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';
// import { API_PATH } from '../Constant/constants';
// import useAuth from '../config/useAuth';

// const TIMING_OPTIONS = [
//   { value: 'MORNING', label: 'Morning' },
//   { value: 'AFTERNOON', label: 'Afternoon' },
//   { value: 'EVENING', label: 'Evening' },
//   { value: 'NIGHT', label: 'Night' }
// ];

// const RELATIVE_TO_MEAL_OPTIONS = [
//   { value: 'BEFORE_MEAL', label: 'Before MEAL' },
//   { value: 'AFTER_MEAL', label: 'After MEAL' },

// ];

// const PrescriptionsPage = () => {
//   const [medicines, setMedicines] = useState([]);

//   const { patientId } = useParams();
//   const { user, token } = useAuth();
//   const [patient, setPatient] = useState(null);
//   useEffect(() => {
//     axios.get(`${API_PATH}/patients/${patientId}`, {
//       headers: { Authorization: `Bearer ${token}` }
//     }).then(res => setPatient(res.data));
//   }, [patientId]);


//   const fetchPatientInfo = async () => {
//   try {
//     const res = await axios.get(`${API_PATH}/patients/${patientId}`, {
//       headers: { Authorization: `Bearer ${token}` }
//     });
//     setPatient(res.data);
//   } catch (err) {
//     console.error('Error fetching patient data:', err);
//   }
// };

// useEffect(() => {
//   const fetchMedicines = async () => {
//     try {
//       const res = await axios.get(`${API_PATH}/medicines`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       setMedicines(res.data);
//     } catch (err) {
//       console.error('Error fetching medicines:', err);
//     }
//   };

//   if (token) fetchMedicines();
// }, [token]);



//   const [records, setRecords] = useState([]);
//   const [form, setForm] = useState({
//     recordDate: '',
//     diagnosis: '',
//     treatment: '',
//     notes: '',
//     prescriptions: [
//       {
//         medicineName: '',
//         durationInDays: '',
//         totalQuantity: '',
//         dosage: [{ quantity: '', timing: '', relativeToMeal: '' }]
//       }
//     ],
//     recommendedTests: [
//       { testName: '', testDescription: '', notes: '' }
//     ]
//   });

//   useEffect(() => {
//     if (patientId && !isNaN(Number(patientId))) fetchRecords();
//   }, [patientId]);

//   const fetchRecords = async () => {
//     try {
//       const res = await axios.get(`${API_PATH}/medicalrecords/patients/${patientId}/records`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       setRecords(res.data);
//     } catch (error) {
//       console.error('Error fetching records:', error);
//     }
//   };

//   const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
//   const handlePrescriptionChange = (idx, field, value) => {
//     const updated = [...form.prescriptions];
//     updated[idx][field] = value;
//     setForm({ ...form, prescriptions: updated });
//   };
//   const handleDosageChange = (pIdx, dIdx, field, value) => {
//     const updated = [...form.prescriptions];
//     updated[pIdx].dosage[dIdx][field] = value;
//     setForm({ ...form, prescriptions: updated });
//   };
//   const removeDosage = (pIdx, dIdx) => {
//     const updated = [...form.prescriptions];
//     updated[pIdx].dosage.splice(dIdx, 1);
//     setForm({ ...form, prescriptions: updated });
//   };
//   const handleTestChange = (idx, field, value) => {
//     const updated = [...form.recommendedTests];
//     updated[idx][field] = value;
//     setForm({ ...form, recommendedTests: updated });
//   };
//   const addPrescription = () => {
//     setForm({
//       ...form,
//       prescriptions: [...form.prescriptions, {
//         medicineName: '', durationInDays: '', totalQuantity: '',
//         dosage: [{ quantity: '', timing: '', relativeToMeal: '' }]
//       }]
//     });
//   };
//   const addDosage = (pIdx) => {
//     const updated = [...form.prescriptions];
//     updated[pIdx].dosage.push({ quantity: '', timing: '', relativeToMeal: '' });
//     setForm({ ...form, prescriptions: updated });
//   };
//   const addTest = () => {
//     setForm({
//       ...form,
//       recommendedTests: [...form.recommendedTests, { testName: '', testDescription: '', notes: '' }]
//     });
//   };

//   const ensureSeconds = (dateStr) => {
//     if (!dateStr) return '';
//     const date = new Date(dateStr);
//     const yyyy = date.getFullYear();
//     const MM = String(date.getMonth() + 1).padStart(2, '0');
//     const dd = String(date.getDate()).padStart(2, '0');
//     const hh = String(date.getHours()).padStart(2, '0');
//     const mm = String(date.getMinutes()).padStart(2, '0');
//     const ss = String(date.getSeconds()).padStart(2, '0');
//     return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
//   };
// console.log(user)


// const generatePrescriptionPDF = () => {
//   if (!user || !user.fullName) {
//     alert('User information is missing');
//     return;
//   }

//   const doc = new jsPDF('p', 'mm', 'a4');
//   const logo = new Image();
//   logo.src = '/hph-logo.png';

//   logo.onload = () => {
//     // Header
//     doc.setFillColor(0, 123, 255); // blue header
//     doc.rect(0, 0, 210, 30, 'F');
//     doc.addImage(logo, 'PNG', 175, 5, 25, 20);
//     doc.setFontSize(16).setTextColor(255).setFont('helvetica', 'bold');
//     doc.text(`Dr. ${user.fullName}`, 10, 12);
//     doc.setFontSize(10).text('Qualification: MBBS, MD', 10, 20);

//     // Patient Info
//     const dob = patient?.dateOfBirth ? new Date(patient.dateOfBirth).toLocaleDateString() : 'N/A';
//     const contact = patient?.contacts?.find(c => c.type?.toLowerCase() === 'phone')?.value || 'N/A';

//     doc.setFontSize(12).setTextColor(0);
//     doc.text(`Patient Name: ${patient?.firstName || ''} ${patient?.lastName || ''}`, 10, 38);
//     doc.text(`Gender: ${patient?.gender || 'N/A'}`, 10, 45);
//     doc.text(`DOB: ${dob}`, 60, 45);
//     doc.text(`Contact: ${contact}`, 130, 45);
//     doc.text(`Date: ${new Date(form.recordDate).toLocaleString()}`, 130, 52);
//     doc.text(`Diagnosis: ${form.diagnosis}`, 10, 58);

//     // Prescription Table
//     const presResult = autoTable(doc, {
//       startY: 65,
//       head: [['Medicine', 'Duration', 'Quantity', 'Dosage']],
//       body: form.prescriptions.map(p => [
//         p.medicineName,
//         `${p.durationInDays} days`,
//         p.totalQuantity,
//         p.dosage.map(d => `${d.quantity} - ${d.timing} (${d.relativeToMeal})`).join('\n')
//       ]),
//       styles: { fontSize: 10 },
//       headStyles: { fillColor: [0, 123, 255] }
//     });

//     // Recommended Tests Table
//     autoTable(doc, {
//       startY: (presResult?.finalY || 100) + 10,
//       head: [['Test Name', 'Description', 'Notes']],
//       body: form.recommendedTests.map(t => [t.testName, t.testDescription, t.notes]),
//       styles: { fontSize: 10 },
//       headStyles: { fillColor: [0, 123, 255] }
//     });

//     // Footer (matching header color)
//     doc.setFillColor(0, 123, 255);
//     doc.rect(0, 285, 210, 12, 'F');
//     doc.setFontSize(10).setTextColor(255);
//     doc.text('Clinic Name | 📍 24 Dummy Street Area | 📞 +12-345 678 9012', 10, 292);

//     // Signature
//     doc.setDrawColor(0);
//     doc.setTextColor(0);
//     doc.line(140, 270, 200, 270);
//     doc.text('Signature', 160, 275);

//     doc.save(`Prescription_Patient_${patientId}.pdf`);
//   };

//   logo.onerror = () => {
//     console.error("❌ Failed to load logo image.");
//     alert("❌ Failed to load logo. Make sure logo512.png is placed in the public folder.");
//   };
// };



// const handleSubmit = async (e) => {
//   e.preventDefault();
//   const cleanedPrescriptions = form.prescriptions.filter(p => p.medicineName.trim() !== '');
//   const cleanedTests = form.recommendedTests.filter(t => t.testName.trim() !== '');

//   const payload = {
//     ...form,
//     recordDate: ensureSeconds(form.recordDate),
//     prescriptions: cleanedPrescriptions,
//     recommendedTests: cleanedTests,
//     attendingDoctorId: user.id,
//     patientId: parseInt(patientId)
//   };

//   try {
//     const response = await axios.post(`${API_PATH}/medicalrecords/patients/${patientId}/records`, payload, {
//       headers: { Authorization: `Bearer ${token}` }
//     });

//     if (response.status === 200 || response.status === 201) {
//       fetchRecords();
//       generatePrescriptionPDF(() => {
//         alert('✅ Prescription saved and PDF generated!');
//       });
//     } else {
//       alert('⚠️ Unexpected server response.');
//     }
//   } catch (error) {
//     console.error('❌ Error:', error);
//     alert('❌ Failed to save prescription. Check console for details.');
//   }
// };




// const handleDelete = async (recordId) => {
//   const confirm = window.confirm("Are you sure you want to delete this record?");
//   if (!confirm) return;

//   try {
//     await axios.delete(`${API_PATH}/medicalrecords/${recordId}`, {
//       headers: { Authorization: `Bearer ${token}` }
//     });
//     alert('✅ Record deleted successfully');
//     fetchRecords(); // refresh records
//   } catch (err) {
//     console.error('❌ Delete error:', err);
//     alert('❌ Failed to delete record.');
//   }
// };






// const handleEdit = (record) => {
//   setForm({
//     id: record.id,
//     recordDate: record.recordDate ? new Date(record.recordDate).toISOString().slice(0, 16) : '',
//     diagnosis: record.diagnosis,
//     treatment: record.treatment,
//     notes: record.notes,
//     prescriptions: record.prescriptions || [],
//     recommendedTests: record.recommendedTests || []
//   });
// };



//   return (
//     <div className="container py-5">
//       <h4>className="mb-4">Prescriptions for Patient #{patientId}</h4>
//       <form onSubmit={handleSubmit}>
//         <input type="datetime-local" name="recordDate" value={form.recordDate} onChange={handleChange} required className="form-control mb-2" />
//         <input type="text" name="diagnosis" placeholder="Diagnosis" value={form.diagnosis} onChange={handleChange} required className="form-control mb-2" />
//         <input type="text" name="treatment" placeholder="Treatment" value={form.treatment} onChange={handleChange} required className="form-control mb-2" />
//         <textarea name="notes" placeholder="Notes" value={form.notes} onChange={handleChange} className="form-control mb-3" />

//         <h5>Prescriptions</h5>
//         {form.prescriptions.map((p, idx) => (
//           <div key={idx} className="mb-3 border p-3">
//            <select
//             value={p.medicineName}
//             onChange={(e) => handlePrescriptionChange(idx, 'medicineName', e.target.value)}
//             className="form-select mb-1"
//           >
//             <option value="">Select Medicine</option>
//             {medicines.map((med) => (
//               <option key={med.id} value={med.name}>
//                 {med.name}
//               </option>
//             ))}
//           </select>

//             <input type="number" placeholder="Duration (days)" value={p.durationInDays} onChange={(e) => handlePrescriptionChange(idx, 'durationInDays', e.target.value)} className="form-control mb-1" />
//             <input type="number" placeholder="Total Quantity" value={p.totalQuantity} onChange={(e) => handlePrescriptionChange(idx, 'totalQuantity', e.target.value)} className="form-control mb-1" />
//             {p.dosage.map((d, dIdx) => (
//               <div key={dIdx} className="d-flex gap-2 mb-1">
//                 <input type="text" placeholder="Quantity" value={d.quantity} onChange={(e) => handleDosageChange(idx, dIdx, 'quantity', e.target.value)} className="form-control" />
//                 <select className="form-control" value={d.timing} onChange={(e) => handleDosageChange(idx, dIdx, 'timing', e.target.value)}>
//                   <option value="">Select Timing</option>
//                   {TIMING_OPTIONS.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//                 </select>
//                 <select className="form-control" value={d.relativeToMeal} onChange={(e) => handleDosageChange(idx, dIdx, 'relativeToMeal', e.target.value)}>
//                   <option value="">Relative to Meal</option>
//                   {RELATIVE_TO_MEAL_OPTIONS.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//                 </select>
//                 <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => removeDosage(idx, dIdx)}>&times;</button>
//               </div>
//             ))}
//             <button type="button" onClick={() => addDosage(idx)} className="btn btn-outline-secondary btn-sm">+ Dosage</button>
//           </div>
//         ))}
//         <button type="button" onClick={addPrescription} className="btn btn-outline-primary mb-3">+ Add Prescription</button>

//         <h5>Recommended Tests</h5>
//         {form.recommendedTests.map((t, idx) => (
//           <div key={idx} className="mb-3 border p-3">
//             <input type="text" placeholder="Test Name" value={t.testName} onChange={(e) => handleTestChange(idx, 'testName', e.target.value)} className="form-control mb-1" />
//             <input type="text" placeholder="Description" value={t.testDescription} onChange={(e) => handleTestChange(idx, 'testDescription', e.target.value)} className="form-control mb-1" />
//             <input type="text" placeholder="Notes" value={t.notes} onChange={(e) => handleTestChange(idx, 'notes', e.target.value)} className="form-control mb-1" />
//           </div>
//         ))}
//         <button type="button" onClick={addTest} className="btn btn-outline-primary mb-3">+ Add Test</button>

//         <button type="submit" className="btn btn-success w-100">Submit and Generate PDF</button>
//       </form>

//       <h4 className="mt-5 mb-4 text-secondary fw-semibold">Previous Records</h4>
//       {records.length === 0 ? (
//         <div className="alert alert-info">No previous records found for this patient.</div>
//       ) : (
//         <div className="table-responsive shadow-sm rounded">
//           <table className="table table-bordered">
//             <thead className="table-light">
//               <tr>
//                 <th>Date</th>
//                 <th>Diagnosis</th>
//                 <th>Treatment</th>
//                 <th>Notes</th>
//                 <th>Prescriptions</th>
//                 <th>Recommended Tests</th>
//                   <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {records.map((rec, idx) => (
//                 <tr key={idx}>
//                   <td>{new Date(rec.recordDate).toLocaleString()}</td>
//                   <td>{rec.diagnosis}</td>
//                   <td>{rec.treatment}</td>
//                   <td>{rec.notes}</td>
//                   <td>
//                     <ul className="list-unstyled mb-0">
//                       {rec.prescriptions?.map((p, i) => (
//                         <li key={i}>
//                           <strong>{p.medicineName}</strong> ({p.durationInDays} days)
//                           <ul>
//                             {p.dosage?.map((d, j) => (
//                               <li key={j}>{d.quantity} - {d.timing} ({d.relativeToMeal})</li>
//                             ))}
//                           </ul>
//                         </li>
//                       ))}
//                     </ul>
//                   </td>
//                   <td>
//                     <ul className="list-unstyled mb-0">
//                       {rec.recommendedTests?.map((t, i) => (
//                         <li key={i}>
//                           <strong>{t.testName}</strong>
//                           {t.testDescription && `: ${t.testDescription}`}
//                           {t.notes && <div><em>Note:</em> {t.notes}</div>}
//                         </li>
//                       ))}
//                     </ul>
//                   </td>

//                   <td>
//   <button
//     className="btn btn-sm btn-primary me-2"
//     onClick={() => handleEdit(rec)}
//   >
//     Edit
//   </button>
//   <button
//     className="btn btn-sm btn-danger"
//     onClick={() => handleDelete(rec.id)}
//   >
//     Delete
//   </button>
// </td>

//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PrescriptionsPage;









import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { API_PATH } from '../Constant/constants';
import useAuth from '../config/useAuth';

const TIMING_OPTIONS = [
  { value: 'MORNING', label: 'Morning' },
  { value: 'AFTERNOON', label: 'Afternoon' },
  { value: 'EVENING', label: 'Evening' },
  { value: 'NIGHT', label: 'Night' }
];

const RELATIVE_TO_MEAL_OPTIONS = [
  { value: 'BEFORE_MEAL', label: 'Before MEAL' },
  { value: 'AFTER_MEAL', label: 'After MEAL' },
];

const PrescriptionsPage = () => {
  const { patientId } = useParams();
  const { user, token } = useAuth();

  const [medicines, setMedicines] = useState([]);
  const [patient, setPatient] = useState(null);
  const [records, setRecords] = useState([]);
  const [form, setForm] = useState({
    recordDate: '',
    diagnosis: '',
    treatment: '',
    notes: '',
    prescriptions: [
      {
        medicineName: '',
        durationInDays: '',
        totalQuantity: '',
        dosage: [{ quantity: '', timing: '', relativeToMeal: '' }]
      }
    ],
    recommendedTests: [
      { testName: '', testDescription: '', notes: '' }
    ]
  });

  // Fetch patient info
  useEffect(() => {
    if (token && patientId) {
      axios.get(`${API_PATH}/patients/${patientId}`, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(res => setPatient(res.data));
    }
  }, [patientId, token]);

  // Fetch all medicines
  useEffect(() => {
    if (token) {
      axios.get(`${API_PATH}/medicines`, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(res => setMedicines(res.data))
        .catch(err => console.error('Error fetching medicines:', err));
    }
  }, [token]);

  // Fetch all records for this patient
  useEffect(() => {
    if (patientId && !isNaN(Number(patientId))) fetchRecords();
  }, [patientId]);

  const fetchRecords = async () => {
    try {
      const res = await axios.get(`${API_PATH}/medicalrecords/patients/${patientId}/records`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRecords(res.data);
    } catch (error) {
      console.error('Error fetching records:', error);
    }
  };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handlePrescriptionChange = (idx, field, value) => {
    const updated = [...form.prescriptions];
    updated[idx][field] = value;
    setForm({ ...form, prescriptions: updated });
  };

  const handleDosageChange = (pIdx, dIdx, field, value) => {
    const updated = [...form.prescriptions];
    updated[pIdx].dosage[dIdx][field] = value;
    setForm({ ...form, prescriptions: updated });
  };

  const removeDosage = (pIdx, dIdx) => {
    const updated = [...form.prescriptions];
    updated[pIdx].dosage.splice(dIdx, 1);
    setForm({ ...form, prescriptions: updated });
  };

  const handleTestChange = (idx, field, value) => {
    const updated = [...form.recommendedTests];
    updated[idx][field] = value;
    setForm({ ...form, recommendedTests: updated });
  };

  const addPrescription = () => {
    setForm({
      ...form,
      prescriptions: [...form.prescriptions, {
        medicineName: '', durationInDays: '', totalQuantity: '',
        dosage: [{ quantity: '', timing: '', relativeToMeal: '' }]
      }]
    });
  };

  const addDosage = (pIdx) => {
    const updated = [...form.prescriptions];
    updated[pIdx].dosage.push({ quantity: '', timing: '', relativeToMeal: '' });
    setForm({ ...form, prescriptions: updated });
  };

  const addTest = () => {
    setForm({
      ...form,
      recommendedTests: [...form.recommendedTests, { testName: '', testDescription: '', notes: '' }]
    });
  };

  const ensureSeconds = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const yyyy = date.getFullYear();
    const MM = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
  };

  const generatePrescriptionPDF = () => {
    if (!user || !user.fullName) {
      alert('User information is missing');
      return;
    }

    const doc = new jsPDF('p', 'mm', 'a4');
    const logo = new Image();
    logo.src = '/hph-logo.png';

    logo.onload = () => {
      doc.setFillColor(0, 123, 255);
      doc.rect(0, 0, 210, 30, 'F');
      doc.addImage(logo, 'PNG', 175, 5, 25, 20);
      doc.setFontSize(16).setTextColor(255).setFont('helvetica', 'bold');
      doc.text(`Dr. ${user.fullName}`, 10, 12);
      doc.setFontSize(10).text('Qualification: MBBS, MD', 10, 20);

      const dob = patient?.dateOfBirth ? new Date(patient.dateOfBirth).toLocaleDateString() : 'N/A';
      const contact = patient?.contacts?.find(c => c.type?.toLowerCase() === 'phone')?.value || 'N/A';

      doc.setFontSize(12).setTextColor(0);
      doc.text(`Patient Name: ${patient?.firstName || ''} ${patient?.lastName || ''}`, 10, 38);
      doc.text(`Gender: ${patient?.gender || 'N/A'}`, 10, 45);
      doc.text(`DOB: ${dob}`, 60, 45);
      doc.text(`Contact: ${contact}`, 130, 45);
      doc.text(`Date: ${new Date(form.recordDate).toLocaleString()}`, 130, 52);
      doc.text(`Diagnosis: ${form.diagnosis}`, 10, 58);

      const presResult = autoTable(doc, {
        startY: 65,
        head: [['Medicine', 'Duration', 'Quantity', 'Dosage']],
        body: form.prescriptions.map(p => [
          p.medicineName,
          `${p.durationInDays} days`,
          p.totalQuantity,
          p.dosage.map(d => `${d.quantity} - ${d.timing} (${d.relativeToMeal})`).join('\n')
        ]),
        styles: { fontSize: 10 },
        headStyles: { fillColor: [0, 123, 255] }
      });

      autoTable(doc, {
        startY: (presResult?.finalY || 100) + 10,
        head: [['Test Name', 'Description', 'Notes']],
        body: form.recommendedTests.map(t => [t.testName, t.testDescription, t.notes]),
        styles: { fontSize: 10 },
        headStyles: { fillColor: [0, 123, 255] }
      });

      doc.setFillColor(0, 123, 255);
      doc.rect(0, 285, 210, 12, 'F');
      doc.setFontSize(10).setTextColor(255);
      doc.text('Clinic Name | 📍 24 Dummy Street Area | 📞 +12-345 678 9012', 10, 292);

      doc.setDrawColor(0);
      doc.setTextColor(0);
      doc.line(140, 270, 200, 270);
      doc.text('Signature', 160, 275);

      doc.save(`Prescription_Patient_${patientId}.pdf`);
    };

    logo.onerror = () => {
      alert("❌ Failed to load logo. Make sure logo is in public folder.");
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cleanedPrescriptions = form.prescriptions.filter(p => p.medicineName.trim() !== '');
    const cleanedTests = form.recommendedTests.filter(t => t.testName.trim() !== '');

    const payload = {
      ...form,
      recordDate: ensureSeconds(form.recordDate),
      prescriptions: cleanedPrescriptions,
      recommendedTests: cleanedTests,
      attendingDoctorId: user.id,
      patientId: parseInt(patientId)
    };

    try {
      let response;
      if (form.id) {
        response = await axios.patch(`${API_PATH}/medicalrecords/${form.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        response = await axios.post(`${API_PATH}/medicalrecords/patients/${patientId}/records`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      if (response.status === 200 || response.status === 201) {
        fetchRecords();
        generatePrescriptionPDF();
        alert('✅ Record saved successfully');
        setForm({
          recordDate: '',
          diagnosis: '',
          treatment: '',
          notes: '',
          prescriptions: [{
            medicineName: '', durationInDays: '', totalQuantity: '',
            dosage: [{ quantity: '', timing: '', relativeToMeal: '' }]
          }],
          recommendedTests: [{ testName: '', testDescription: '', notes: '' }]
        });
      }
    } catch (error) {
      console.error('❌ Error:', error);
      alert('❌ Failed to save record.');
    }
  };

  const handleEdit = (record) => {
    const formattedDate = record.recordDate
      ? new Date(record.recordDate).toISOString().slice(0, 16)
      : '';

    setForm({
      id: record.id,
      recordDate: formattedDate,
      diagnosis: record.diagnosis || '',
      treatment: record.treatment || '',
      notes: record.notes || '',
      prescriptions: (record.prescriptions || []).map(p => ({
        medicineName: p.medicineName || '',
        durationInDays: p.durationInDays || '',
        totalQuantity: p.totalQuantity || '',
        dosage: (p.dosage || []).map(d => ({
          quantity: d.quantity || '',
          timing: d.timing || '',
          relativeToMeal: d.relativeToMeal || ''
        }))
      })),
      recommendedTests: (record.recommendedTests || []).map(t => ({
        testName: t.testName || '',
        testDescription: t.testDescription || '',
        notes: t.notes || ''
      }))
    });
  };

  const handleDelete = async (recordId) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    try {
      await axios.delete(`${API_PATH}/medicalrecords/${recordId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('✅ Record deleted successfully');
      fetchRecords();
    } catch (err) {
      console.error('❌ Delete error:', err);
      alert('❌ Failed to delete record.');
    }
  };

  // Return JSX code for rendering (your existing code is fine for this part)

  // 🟦 Keep your existing return UI here, no changes needed.
  // If you want me to include the full return JSX again, let me know — it's already correctly structured.

  return (
    // ... [Same JSX from your original render]
    <>  <div className="container py-5">
    <h4 className="mb-4">
      Prescriptions for Patient #{patientId}
    </h4>
    <h4 className="fs-5 mb-3">
      {form.id ? 'Edit Prescription Record' : 'Add New Prescription Record'}
    </h4>

    <form onSubmit={handleSubmit}>
      <input
        type="datetime-local"
        name="recordDate"
        value={form.recordDate}
        onChange={handleChange}
        required
        className="form-control mb-2"
      />
      <input
        type="text"
        name="diagnosis"
        placeholder="Diagnosis"
        value={form.diagnosis}
        onChange={handleChange}
        required
        className="form-control mb-2"
      />
      <input
        type="text"
        name="treatment"
        placeholder="Treatment"
        value={form.treatment}
        onChange={handleChange}
        required
        className="form-control mb-2"
      />
      <textarea
        name="notes"
        placeholder="Notes"
        value={form.notes}
        onChange={handleChange}
        className="form-control mb-3"
      />

      <h4>Prescriptions</h4>
      {form.prescriptions.map((p, idx) => (
        <div key={idx} className="mb-3 border p-3 rounded shadow-sm">
          <select
            value={p.medicineName}
            onChange={(e) => handlePrescriptionChange(idx, 'medicineName', e.target.value)}
            className="form-select mb-1"
          >
            <option value="">Select Medicine</option>
            {medicines.map((med) => (
              <option key={med.id} value={med.name}>
                {med.name}
              </option>
            ))}
          </select>

          <input
            type="number"
            placeholder="Duration (days)"
            value={p.durationInDays}
            onChange={(e) => handlePrescriptionChange(idx, 'durationInDays', e.target.value)}
            className="form-control mb-1"
          />
          <input
            type="number"
            placeholder="Total Quantity"
            value={p.totalQuantity}
            onChange={(e) => handlePrescriptionChange(idx, 'totalQuantity', e.target.value)}
            className="form-control mb-2"
          />

          {p.dosage.map((d, dIdx) => (
            <div key={dIdx} className="d-flex gap-2 mb-2">
              <input
                type="text"
                placeholder="Quantity"
                value={d.quantity}
                onChange={(e) => handleDosageChange(idx, dIdx, 'quantity', e.target.value)}
                className="form-control"
              />
              <select
                className="form-control"
                value={d.timing}
                onChange={(e) => handleDosageChange(idx, dIdx, 'timing', e.target.value)}
              >
                <option value="">Select Timing</option>
                {TIMING_OPTIONS.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
              <select
                className="form-control"
                value={d.relativeToMeal}
                onChange={(e) => handleDosageChange(idx, dIdx, 'relativeToMeal', e.target.value)}
              >
                <option value="">Relative to Meal</option>
                {RELATIVE_TO_MEAL_OPTIONS.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                onClick={() => removeDosage(idx, dIdx)}
              >
                &times;
              </button>
            </div>
          ))}

          <button
            type="button"
            onClick={() => addDosage(idx)}
            className="btn btn-outline-secondary btn-sm mt-1 btn-color"
          >
            + Add Dosage
          </button>
        </div>
      ))}

      <button
        type="button"
        onClick={addPrescription}
        className="btn btn-outline-primary mb-3 btn-color"
      >
        + Add Prescription
      </button>

      <h4>Recommended Tests</h4>
      {form.recommendedTests.map((t, idx) => (
        <div key={idx} className="mb-3 border p-3 rounded shadow-sm">
          <input
            type="text"
            placeholder="Test Name"
            value={t.testName}
            onChange={(e) => handleTestChange(idx, 'testName', e.target.value)}
            className="form-control mb-1"
          />
          <input
            type="text"
            placeholder="Description"
            value={t.testDescription}
            onChange={(e) => handleTestChange(idx, 'testDescription', e.target.value)}
            className="form-control mb-1"
          />
          <input
            type="text"
            placeholder="Notes"
            value={t.notes}
            onChange={(e) => handleTestChange(idx, 'notes', e.target.value)}
            className="form-control mb-1"
          />
        </div>
      ))}

      <button
        type="button"
        onClick={addTest}
        className="btn btn-outline-primary mb-4 btn-color"
      >
        + Add Test
      </button>

      <button type="submit" className="btn btn-color w-100">
        {form.id ? 'Update Record and Generate PDF' : 'Submit and Generate PDF'}
      </button>
    </form>

    <h4 className="mt-5 mb-4 ">Previous Records</h4>
    {records.length === 0 ? (
      <div className="alert alert-info">
        No previous records found for this patient.
      </div>
    ) : (
      <div className="table-responsive shadow-sm rounded">
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Date</th>
              <th>Diagnosis</th>
              <th>Treatment</th>
              <th>Notes</th>
              <th>Prescriptions</th>
              <th>Recommended Tests</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {records.map((rec, idx) => (
              <tr key={idx}>
                <td>{new Date(rec.recordDate).toLocaleString()}</td>
                <td>{rec.diagnosis}</td>
                <td>{rec.treatment}</td>
                <td>{rec.notes}</td>
                <td>
                  <ul className="list-unstyled mb-0">
                    {rec.prescriptions?.map((p, i) => (
                      <li key={i}>
                        <strong>{p.medicineName}</strong> ({p.durationInDays} days)
                        <ul>
                          {p.dosage?.map((d, j) => (
                            <li key={j}>{d.quantity} - {d.timing} ({d.relativeToMeal})</li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </td>
                <td>
                  <ul className="list-unstyled mb-0">
                    {rec.recommendedTests?.map((t, i) => (
                      <li key={i}>
                        <strong>{t.testName}</strong>
                        {t.testDescription && `: ${t.testDescription}`}
                        {t.notes && <div><em>Note:</em> {t.notes}</div>}
                      </li>
                    ))}
                  </ul>
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-primary me-2"
                    onClick={() => handleEdit(rec)}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(rec.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div> </>
  );
};

export default PrescriptionsPage;



